import React, { useMemo } from "react";

import RecentlyViewedCarousel from '@usap/carparts/src/shared/components/RecommendationWidgets/RecentlyViewedCarousel'
import { getRecommendationConfig } from '@usap/carparts/src/shared/components/RecommendationWidgets/RecommendationMiddleware'
import Recommendations from '@usap/carparts/src/shared/components/RecommendationWidgets/Recommendations/Recommendations'

// Define the type for recommendation settings
interface RecommendationSetting {
  strategy?: string;
  label?: string;
  isHardCodeComponentEnable?: boolean;
  showAddToCart?: boolean;
  showGuaranteedToFit?: boolean;
}

interface Props {
  pageRecommendationsSettings: RecommendationSetting[];
}

export const getHardcodedRecomWidgets = ({ pageRecommendationsSettings }: Props) => {
  return useMemo(() => (
    <div id="recommendationWrapper">
      {pageRecommendationsSettings.map((recommendationSetting, index) => {
        if (recommendationSetting?.strategy === "RecentlyViewed" && recommendationSetting?.isHardCodeComponentEnable) {
          return (
            <RecentlyViewedCarousel
              key={index}
              label={recommendationSetting?.label}
              widgetName={recommendationSetting?.strategy}
            />
          );
        }

        const recommendationUrl = getRecommendationConfig(recommendationSetting);
        return (
          recommendationUrl &&
          recommendationSetting?.isHardCodeComponentEnable && (
            <Recommendations
              key={index}
              label={recommendationSetting?.label || recommendationSetting?.strategy}
              widgetName={recommendationSetting?.strategy}
              recommendationUrl={recommendationUrl}
              showAddToCart={recommendationSetting?.showAddToCart || false}
              showGuaranteedToFit={recommendationSetting?.showGuaranteedToFit || false}
              recommendationData={recommendationSetting}
            />
          )
        );
      })}
    </div>
  ), [pageRecommendationsSettings]);
};